import React from "react";

// Style
import "./FieldSelect.scss";

// Components
import Img from "components/Img";
import Select, { components } from "react-select";

// ClassName
import clsx from "clsx";

// Type
type TOptionUnit = {
  label?: string | null | undefined | unknown,
  value?: string | null | undefined | unknown | number,
};

// Interface
interface ISelect {
  styles?: {},
  name?: string,
  onChange?: any,
  register?: any,
  label?: string,
  title?: string,
  customRef?: any,
  isError?: boolean,
  msgError?: string,
  className?: string,
  disabled?: boolean,
  required?: boolean,
  placeholder?: string,
  isWhiteArrow?: boolean,
  classNameLabel?: string,
  options?: Array<TOptionUnit>,
  value?: TOptionUnit | [] | string | undefined,
}

export const FieldSelect: React.FC<ISelect> = (props) => {
  const {
    name,
    label,
    value,
    title,
    styles,
    options,
    isError,
    onChange,
    disabled,
    required,
    register,
    msgError,
    customRef,
    className,
    placeholder,
    isWhiteArrow,
    classNameLabel
  } = props;

  const cnWrapper = clsx(
    "field-select",
    className ? className : "",
    required ? "field-select__required" : "",
    disabled ? "field-select__disabled" : ""
  );

  const cnLabel = clsx(
    "field-select__label",
    classNameLabel ? classNameLabel : ""
  );

  const cnIndicator = clsx(
    isWhiteArrow ? "field-select__arrow-white" : ""
  );

  const DropdownIndicator = (props: any) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <Img
            isSvg
            name="arrowDropdownSvg"
            className={cnIndicator}
          />
        </components.DropdownIndicator>
      )
    );
  };

  const titleValue = required ? title ? title : "Field is required" : "";

  return (
    <div className={cnWrapper}>
      {label &&
        <span
          title={titleValue}
          className={cnLabel}
        >
	        {label}
				</span>}
      <Select
        {...register}

        name={name}
        value={value}
        title={title}
        ref={customRef}
        styles={styles}
        options={options}
        onChange={onChange}
        isDisabled={disabled}
        placeholder={placeholder}
        components={{ DropdownIndicator }}
      />

      {isError && <div className="field-select__hint">
        {msgError}
      </div>}
    </div>
  );
};

export default FieldSelect;